import React, { useState, useEffect, useCallback } from 'react';
import AddTeamMember from '@components/team-member/AddTeamMember';
import EditTeamMember from '@components/team-member/edit-team-member';
import RemoveTeamMember from '@components/team-member/RemoveTeamMember';
import OrganizationDetails from '@components/team-member/organization-details';

const TeamMember = () => {
  const [partnerCarehomeId, setParnerCarehomeId] = useState('');
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [selectedTeamMemberId, setSelectedTeamMemberId] = useState('');
  const [hasError, setHasError] = useState(false);

  const onFormSubmit = () => {
    setIsFormSubmitted(!isFormSubmitted);
  };

  const validateTeamMemberSelection = useCallback(() => {
    if (!selectedTeamMemberId) {
      setHasError(true);
      return false;
    }
    setHasError(false);
    return true;
  }, [selectedTeamMemberId]);

  useEffect(() => {
    if (selectedTeamMemberId !== '') {
      validateTeamMemberSelection();
    }
  }, [selectedTeamMemberId, validateTeamMemberSelection]);

  useEffect(() => {
    setParnerCarehomeId(localStorage.getItem('partnerId') || '');
  }, [partnerCarehomeId]);

  return (
    <div className="govuk-width-container">
      <OrganizationDetails />
      <AddTeamMember
        partnerCarehomeId={partnerCarehomeId}
        onFormSubmit={onFormSubmit}
      />
      <EditTeamMember
        partnerCarehomeId={partnerCarehomeId}
        isFormSubmitted={isFormSubmitted}
        selectedTeamMemberId={selectedTeamMemberId}
        setSelectedTeamMemberId={setSelectedTeamMemberId}
        hasError={hasError}
      />
      <RemoveTeamMember
        selectedTeamMemberId={selectedTeamMemberId}
        setSelectedTeamMemberId={setSelectedTeamMemberId}
        validateTeamMemberSelection={validateTeamMemberSelection}
        partnerCarehomeId={partnerCarehomeId}
        onFormSubmit={onFormSubmit}
      />
    </div>
  );
};

export default TeamMember;
